import React from "react"
import s from './DragDropArea.module.scss'
import preloader from '../../../../assets/UserRecognition/preloader.png'
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"


export const DragDropArea = (props) => {
    const { error } = useSelector(state => state.recognize)
    const { t } = useTranslation()

    const changeArea = () => {
        if (props.status === 'loading') {
            return (
                <div className={s.preloader}>
                    <div className={s.drop_area}>
                        <img src={preloader} alt="" />
                        <div>{t('inRecognitionProcess')}</div>
                    </div>
                    <div className={s.drop_area_mobile}>
                        <img src={preloader} alt="" />
                        <div>{t('inRecognitionProcess')}</div>
                    </div>
                </div>
            )
        }
        else if (props.voice && !error && !props.drag) {
            return (
                <>
                    <div className={s.drop_area}
                        onDragStart={e => props.dragStartHandler(e)}
                        onDragLeave={e => props.dragLeaveHandler(e)}
                        onDragOver={e => props.dragStartHandler(e)}

                    >{t('isLoaded')}</div>
                    <div className={s.drop_area_mobile}>
                    {t('isLoaded')}
                    </div>
                </>

            )

        }
        else if (props.drag || (props.drag && error)) {
            return (
                <div className={s.drop_area}
                    onDragStart={e => props.dragStartHandler(e)}
                    onDragLeave={e => props.dragLeaveHandler(e)}
                    onDragOver={e => props.dragStartHandler(e)}
                    onDrop={e => props.onDropHandler(e)}
                >{t('putFile')}</div>
            )

        }
        else if (!props.drag && !props.voice) {
            return (
                <>
                    <div className={s.drop_area}
                        onDragStart={e => props.dragStartHandler(e)}
                        onDragLeave={e => props.dragLeaveHandler(e)}
                        onDragOver={e => props.dragStartHandler(e)}
                    >{t('dragDrop')}</div>
                    <div className={s.drop_area_mobile}>
                        {t('uploadFileMob')}
                    </div>
                </>

            )

        }
        else if (error && !props.drag) {
            return (
                <>
                    <div className={s.preloader}>
                        <div className={s.drop_area}
                            onDragStart={e => props.dragStartHandler(e)}
                            onDragLeave={e => props.dragLeaveHandler(e)}
                            onDragOver={e => props.dragStartHandler(e)}
                            onDrop={e => props.onDropHandler(e)}
                        >{t('errorVoice')}</div>
                    </div>
                    <div className={s.drop_area_mobile}>
                    {t('errorVoice')}
                    </div>
                </>
            )
        }
    }
    return (

        <div>
            <div className={s.dragDrop}>
                {changeArea()}
            </div>

        </div>

    )
}